import React from 'react'
import LoaderBar from './LoaderBar'

function SubmitBtn({isLoading, text, onclick}) {
    return (
        <button onClick={onclick ? () => onclick() : null} className="submit-btn">{isLoading ? <LoaderBar btnIsColored={true} /> : text ?? "Save"}</button>
    )
}

export default SubmitBtn